import { useMutation } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';

import type {
  SendTestDigestParams,
  SendTestDigestResponse,
} from '../model/types';

export const sendTestDigestAPI = async (params?: SendTestDigestParams) => {
  const response = await baseAPI.post<SendTestDigestResponse>(
    '/portal-digest/test-send',
    params ?? {},
  );
  return response.data;
};

export const useSendTestDigest = () => {
  return useMutation({ mutationFn: sendTestDigestAPI });
};
